<template>
  <div class="index" style="background-color: rgb(241, 242, 244);">
    <!-- 顶部 -->

    <topGrey></topGrey>
    <!-- 大图 -->
    <pic></pic>
    <!-- 内容 -->
    <div class="part part3-totle flex_row_center">
      <div class="main">
        <div class="title">
          <img v-lazy="pictureBaseUrl+'/title_xian@2x.png'" style="width:100%" alt />
          <div class="title-word" style="color:#fff;">评审类目</div>
          <div class="title-grey" style="color:#fff;">Review category</div>
        </div>
        <b-container class="bv-example-row">
          <b-row>
            <b-col
              sm="12"
              md="4"
              style
              class="change-box2"
              v-for="item in list1"
              v-bind:key="item.index"
              :style="{color:item.color}"
            >
              <div class="part1box" :style="{backgroundImage:item.img}">
                <div class="flex_row_center part1-logo">
                  <img v-lazy="item.logo" alt />
                </div>
                <div
                  style="font-size:18px;text-align:center;line-height:40px;color: #0b69ba;"
                >{{item.word1}}</div>
                <div class="part1-line"></div>
                <div style="font-size:14px;color: #0b69ba;" class="part1-word22">{{item.word2}}</div>
              </div>
              <div class="part3-blue">
                <div v-html="item.word2"></div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>

    <div class="part" id="service">
      <div class="flex_row_center">
        <div class="main title">
          <img v-lazy="pictureBaseUrl+'/title_xian1@2x.png'" style="width:100%" alt />
          <div class="title-word">我们的服务</div>
          <div class="title-grey">Our services</div>
        </div>
      </div>
      <!-- <div class="flex_row_center" id="service">
        <div class="main">
          <b-container class="bv-example-row">
            <b-row>
              <b-col sm="4" class="flex_row_center" v-for="item in list2" v-bind:key="item.index">
                <div class="part2box" :style="{backgroundImage:item.img}">
                  <div class="flex_row_center">
                    <img v-lazy="item.logo" alt class="six-logo" />
                  </div>
                  <div style="line-height:40px;font-size:16px;font-weight:600;">{{item.word1}}</div>
                  <div style="font-size:12px;">{{item.word2}}</div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div> -->
      <div class  >
        <!-- <div id="show-btn" @click="showModal"> -->
        <div id="show-btn" >
          <img v-lazy="pictureBaseUrl+'/main/服务流程1920.jpg'" class="index-part3" alt />
        </div>
        <b-modal ref="my-modal" hide-footer title="职称申报资格评估" style="text-align:center;width:100%;">
          <ceping ref="childCe"></ceping>
          <div class="flex_row_between">
            <b-button
              class="mt-3"
              style="margin-right:10%;"
              variant="outline-danger"
              block
              @click="hideModal"
            >提交</b-button>
            <b-button class="mt-3" variant="outline-warning" block @click="toggleModal">取消</b-button>
          </div>
        </b-modal>
      </div>
      <div class="flex_row_center" >
        <div class="title main">
          <img src="../assets/title_xian1@2x.png" style="width:100%" alt />
          <div class="title-word">专业保障</div>
          <div class="title-grey">Professional guarantee</div>
        </div>
      </div>
<div>
  <img v-lazy="pictureBaseUrl+'/main/专业保障.jpg'" class="index-part3" alt />
</div>

      <!-- <div class="index-part4">
        <b-container class="bv-example-row">
          <b-row>
            <b-col sm="3" class v-for="item in part4list" v-bind:key="item.index">
              <img v-lazy="item.imglogo" alt class="part4-logo" />
              <div style="color:#258FFC;font-size:16px;">{{item.name}}</div>
              <div style="color:#666666;font-size:12px;">{{item.word}}</div>
            </b-col>
          </b-row>
        </b-container>
      </div> -->


      <div class="flex_row_center"  id="guarantee">
        <div class="title main">
          <img src="../assets/title_xian1@2x.png" style="width:100%" alt />
          <div class="title-word">服务案例</div>
          <div class="title-grey">Certificate Sample</div>
        </div>
      </div>
      <Certificate></Certificate>
      
      <div class="flex_row_center">
        <div class="title main">
          <img src="../assets/title_xian1@2x.png" style="width:100%" alt />
          <div class="title-word">职称好处</div>
          <div class="title-grey">advantage</div>
        </div>
      </div>
      <Advantage></Advantage>
    </div>
    <div class="flex_row_center" id="about">
      <div class="title main">
        <img v-lazy="pictureBaseUrl+'/title_xian1@2x.png'" style="width:100%" alt />
        <div class="title-word">关于我们</div>
        <div class="title-grey">About us</div>
      </div>
    </div>
    <div class="flex_row_center">
      <div class="main" style="width:100%; margin-bottom: 30px;">
  <img v-lazy="pictureBaseUrl+'/main/关于我们.jpg'" class="index-part3" alt />
</div>
</div>

    <!-- <div class="flex_row_center">
      <div class="main">
        <b-card no-body class="overflow-hidden">
          <b-row no-gutters>
            <b-col md="6">
              <div class="card-box">
                <div class="card-box-top">
                  <img v-lazy="pictureBaseUrl+'/8_one@2x.png'" alt />
                </div>
                <div class="card-box-title">我们的团队</div>
                <div class="card-box-line"></div>
                <div class="card-box-word" :title="myteam">{{myteam}}</div>
              </div>
            </b-col>
            <b-col md="6">
              <b-card-img v-lazy="cardimgone" class="rounded-0"></b-card-img>
            </b-col>
          </b-row>
        </b-card>

        <b-card no-body class="overflow-hidden">
          <b-row no-gutters>
            <b-col md="6">
              <b-card-img v-lazy="cardimgtwo" class="rounded-0"></b-card-img>
            </b-col>
            <b-col md="6">
              <div class="card-box card-box2">
                <div class="card-box-top">
                  <img v-lazy="pictureBaseUrl+'/8_two@2x.png'" alt />
                </div>
                <div class="card-box-title">我们的优势</div>
                <div class="card-box-line"></div>
                <div class="card-box-word" :title="myyoushi">{{myyoushi}}</div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </div>
    </div> -->
    <div class="flex_row_center">
        <div class="title main">
          <img src="../assets/title_xian1@2x.png" style="width:100%" alt />
          <div class="title-word">合作伙伴</div>
          <div class="title-grey">partners</div>
        </div>
      </div>
    <Partners></Partners>
    <!-- 底部 -->
    <bottomLan></bottomLan>
    <!-- 固定窗口 -->
    <div class="guding">
      <a target="_blank" style href="http://wpa.qq.com/msgrd?v=3&uin=1853041749&site=qq&menu=yes">
        <img v-lazy="pictureBaseUrl+'/main/侧边联系我们.png'" alt class />
      </a>
    </div>
    <div class="beianhao">
      <!-- 公司地址：宁波市鄞州区宁南北路808号慧和大厦1816A -->
    </div>
  </div>
</template>

<script>
import topGrey from "@/components/public/top";
import pic from "@/components/public/pic";
import bottomLan from "@/components/public/bottomLan";
import ceping from "@/components/public/ceping";
import Certificate from "@/components/public/certificate";
import Advantage from "@/components/public/advantage";
import Partners from "@/components/public/partners";

var global = require("@/utils/global");

export default {
  name: "index",
  components: { topGrey, pic, bottomLan, ceping ,Certificate,Advantage,Partners},
  data() {
    return {
      msg: "home",
      ossurl: "",

      pictureBaseUrl: global.pictureBaseUrl,
      myteam:
        "宁波歌珊企业管理有限公司，前身成立于 2016 年，总部位于浙江宁波。公司的服务范围广泛，涵盖了多个行业和领域。公司在浙江地区主营职称评审业务，致力于为企业和个人提供专业、高效、全面的职称评审服务。我们的团队由经验丰富的职称评审专家和专业顾问组成，他们是一支经验丰富、专业素质过硬的团队，能够为客户提供全面的指导和支持。",
      myyoushi:
        "宁波歌珊秉承“专业、诚信、服务、创新”的理念，以客户需求为导向，不断提升服务质量和水平，为客户提供最优质的职称评审服务。公司注重与客户的沟通和合作，充分了解客户的需求和期望，为客户提供个性化的职称评审解决方案。 ",
      cardimgone: global.pictureBaseUrl + "/about/about1.jpg",
      cardimgtwo: global.pictureBaseUrl + "/about/about2.jpg",
      list1: [
        {
          //          img: "url(" + require("./../assets/3_jainzhu_beijing@2x.png") + ")",
          img:
            "url(" + global.pictureBaseUrl + "/3_jainzhu_beijing@2x.png" + ")",
          //          logo: require("./../assets/3_jainzhu_icon@2x.png"),
          logo: global.pictureBaseUrl + "/3_jainzhu_icon@2x.png",
          word1: "建设工程专业",
          word2:
            "建筑设计、 风景园林（景观设计）、建筑结构、 工程勘察、 岩土工程、 燃气工程、暖通工程、建筑电气（建筑智能化）、建筑施工、 建筑装饰、建筑机械、给排水、市政道路（桥梁）、建筑工程管理、 建筑材料、 工程造价、白蚁防治、装配式建筑、硅酸盐、非金属矿及制品、无机非金属材料..."
        },
        {
          //          img: "url(" + require("./../assets/3_jixie_beijing@2x.png") + ")",
          img: "url(" + global.pictureBaseUrl + "/3_jixie_beijing@2x.png" + ")",
          //            logo: require("./../assets/3_jixie_icon@2x.png"),
          logo: global.pictureBaseUrl + "/3_jixie_icon@2x.png",
          word1: "自然资源",
          color: "#0B69BA",
          word2:
            "地质勘查： 基础地质、勘查技术与工程、水工环地质、 物化探、测试；测绘和地理信息:大地测量、工程测量、摄影测量、界限与权籍测绘、海洋测绘、地理信息系统工程与地图编制、地理信息、导航电子地图制作、地图服务；海洋工程：海洋观测预报、海洋防灾减灾、海洋生态预警监测、海洋技术、海洋工程、海洋生态环境、海洋资源利用与保护；土地工程 ：土地调查、土地评价、土地整治与生态修复、 土地信息化、不动产登记；国土空间规划：城乡规划、土地规划、主体功能区规划"
        },
        {
          //          img: "url(" + require("./../assets/3_jiaotong_beijing@2x.png") + ")",
          img: "url(" + global.pictureBaseUrl + "/dianli.png" + ")",
          //          logo: require("./../assets/3_dainli_icon@2x.png"),
          logo: global.pictureBaseUrl + "/main/水利专业.png",
          word1: "水利专业",
          color: "#FFFFFF",
          word2:
            "水资源、水生态和江河治理、水利工程管理、防汛抗旱减灾、水利水电工程建筑、水利工程施工、农田水利、水电站动力设备、电力系统及自动化、水力学及河流动力学、水文与水资源、工程地质及水文地质、水利机械、水利测绘、水利工程造价、水利工程规划设计、水土保持、环境保护、工程检测与试验、水利工程信息化、港口海岸及近海工程、水利工程建设监理、水利工程质量监督、水利工程运行管理、水利工程技术开发与推广、水利防灾减灾、征地移民..."
        },
        {
          //          img: "url(" + require("./../assets/3_jiaotong_beijing@2x.png") + ")",
          img:
            "url(" + global.pictureBaseUrl + "/3_jiaotong_beijing@2x.png" + ")",
          //          logo: require("./../assets/3_jaiotong_icon@2x.png"),
          logo: global.pictureBaseUrl + "/3_jaiotong_icon@2x.png",
          word1: "交通运输专业",
          color: "#0B69BA",
          word2:
            " 交通运输规划、工程勘察、 公路工程、桥隧工程、道桥工程、 港口航道与海岸工程、给排水工程、工程景观、 岩土工程、 工程管理、试验检测、工程造价、船舶工程、机电设备、 海事管理、交通信息与控制工程、运输与物流管理、交通安全设施、 港口装卸工艺、工程水文、 工程测量、环境保护、交通建筑..."
        },
        {
          //          img: "url(" + require("./../assets/3_yiyao_beijing@2x.png") + ")",
          img: "url(" + global.pictureBaseUrl + "/3_yiyao_beijing@2x.png" + ")",
          //          logo: require("./../assets/3_yiyao_icon@2x.png"),
          logo: global.pictureBaseUrl + "/main/化工.png",
          word1: "化工专业",
          color: "#FFFFFF",
          word2:
            "生物化工、化学分析、化学工程、化学热力工程、应用化学、无机化工、有机化工、材料化工、精细化工、高分子化工、化学工艺、化学制药、化学工程设计、化工技术研发、化工建设管理、化工分析、化工质量管理与标准化、化工产业规划、化学工程技术、化工安全技术、高分子材料与工程、硅酸盐工艺、低温制冷工程、腐蚀与防腐工程、橡胶工艺、橡胶技术、化工制造管理、化工环保治理技术、化工安全技术与管理、化工装备及自动化技术、化工配套公用工程、化工材料应用技术、化工情报信息及化工知识产权、化工环保技术与管理、..."
        },
        {
          //          img: "url(" + require("./../assets/3_qita_beijing@2x.png") + ")",
          img: "url(" + global.pictureBaseUrl + "/3_qita_beijing@2x.png" + ")",
          //          logo: require("./../assets/3_qita_icon@2x.png"),
          logo: global.pictureBaseUrl + "/3_qita_icon@2x.png",
          word1: "其他专业",
          color: "#0B69BA",
          word2: "机电制造、信息技术、高级经济师、生态环境、材料工程、安全工程、特种设备、食品工程、轻工工程、爆破工程、矿山工程、林业工程、医疗器械、汽车制造、港口工程、标准化、计量和质量 等专业"
        }
      ],
      list2: [
        {
          color: "rgb(254,164,17)",
          //          img:
          //            "url(" +
          //            require("./../assets/4_guanjiafuwu_duobianxing3@2x.png") +
          //            ")",
          img:
            "url(" +
            global.pictureBaseUrl +
            "/4_guanjiafuwu_duobianxing3@2x.png" +
            ")",
          //          logo: require("./../assets/4_guanjiafuwu_icon@2x.png"),
          logo: global.pictureBaseUrl + "/4_guanjiafuwu_icon@2x.png",
          word1: "职称评审前信息咨询",
          word2:
            "包括学历、社保、劳动合同、继续教育、论文等条件咨询与解决方案辅导"
        },
        {
          color: "rgb(254,164,17)",
          //          img:
          //            "url(" +
          //            require("./../assets/4_guanjiafuwu_duobianxing2@2x.png") +
          //            ")",
          img:
            "url(" +
            global.pictureBaseUrl +
            "/4_guanjiafuwu_duobianxing2@2x.png" +
            ")",
          //          logo: require("./../assets/4_guochengfuwu_icon@2x.png"),
          logo: global.pictureBaseUrl + "/4_guochengfuwu_icon@2x.png",
          word1: "职称评审过程服务",
          word2:
            "一站式服务，专业老师全程指导材料准备，修改，申报。为您降低时间成本，高效完成评审"
        },
        {
          color: "rgb(254,164,17)",
          /*img:
            "url(" +
            require("./../assets/4_xinxizixun_duobianxing1@2x.png") +
            ")",*/
          img:
            "url(" +
            global.pictureBaseUrl +
            "/4_xinxizixun_duobianxing1@2x.png" +
            ")",
          //          logo: require("./../assets/4_xinxizixun_icon@2x.png"),
          logo: global.pictureBaseUrl + "/4_xinxizixun_icon@2x.png",
          word1: "职称评审管家服务",
          word2:
            "提供涵盖继续教育、论文、专利、业绩等全程知识服务，为中高级职称评审准备完整的职称材料"
        }
      ],
      part4list: [
        {
          //          imglogo: require("./../assets/6_xinxiquanmian_icon@2x.png"),
          imglogo: global.pictureBaseUrl + "/6_xinxiquanmian_icon@2x.png",
          name: "信息全面",
          word:
            "专业老师收集和解读浙江省内各市职称政策信息，帮助您更好理解职称政策"
        },
        {
          //          imglogo: require("./../assets/6_tongguolv_icon@2x.png"),
          imglogo: global.pictureBaseUrl + "/6_tongguolv_icon@2x.png",
          name: "高通过率",
          word: "拥有强大的评审老师资源，职称评审案例通过率高达87%"
        },
        {
          //          imglogo: require("./../assets/6_hulainwang_icon@2x.png"),
          imglogo: global.pictureBaseUrl + "/6_hulainwang_icon@2x.png",
          name: "互联网+",
          word: "首创“换联网+”服务，让你足不出户，轻松享受服务"
        },
        {
          //          imglogo: require("./../assets/6_anquan_icon@2x.png"),
          imglogo: global.pictureBaseUrl + "/6_anquan_icon@2x.png",
          name: "安全性",
          word: "与每一位客户签署合作协议并且提供开票服务，让你免于后顾之忧"
        }
      ]
    };
  },
  mounted() {
    if (process.env.NODE_ENV === "production") {
      this.ossurl =
        "https://oss-miaojiangmin.oss-cn-hangzhou.aliyuncs.com/zjzc789/";
    } else {
      //axios.defaults.baseURL = "http://localhost:8001";
      this.ossurl = "";

      // axios.defaults.baseURL = "http://localhost:9090/api/v1";
    }
    this.ossurl =
      "https://oss-miaojiangmin.oss-cn-hangzhou.aliyuncs.com/zjzc789/";
  },
  methods: {
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      let chil = this.$refs["childCe"];
      var changeData = chil.changeData;
      console.log(chil.changeData);
      //判断校验
      if (changeData.select1 == "") {
        this.$bvToast.toast("请选择工作地点", {
          title: "温馨提示",
          autoHideDelay: 2000,
          appendToast: true
        });
        return;
      }
      if (changeData.select2 == "") {
        this.$bvToast.toast("请选择学历情况", {
          title: "温馨提示",
          autoHideDelay: 2000,
          appendToast: true
        });
        return;
      }
      if (changeData.select3 == "") {
        this.$bvToast.toast("请选择已获证书", {
          title: "温馨提示",
          autoHideDelay: 2000,
          appendToast: true
        });
        return;
      }
      if (changeData.select4 == "") {
        this.$bvToast.toast("请选择工作年限", {
          title: "温馨提示",
          autoHideDelay: 2000,
          appendToast: true
        });
        return;
      }
      if (changeData.input1text == "") {
        this.$bvToast.toast("请输入毕业时间", {
          title: "温馨提示",
          autoHideDelay: 2000,
          appendToast: true
        });
        return;
      }
      if (changeData.input2text == "") {
        this.$bvToast.toast("请输入联系方式", {
          title: "温馨提示",
          autoHideDelay: 2000,
          appendToast: true
        });
        return;
      }
      //提交接口发送 post 请求
      var form = [
        changeData.select1,
        changeData.select2,
        changeData.select3,
        changeData.select4,
        changeData.input1text,
        changeData.input2text
      ];

      var form1 = {
        工作地点: changeData.select1,
        学历情况: changeData.select2,
        毕业时间: changeData.select3,
        已获证书: changeData.select4,
        工作年限: changeData.input1text,
        联系方式: changeData.input2text
      };

      var formJsonStr = JSON.stringify(form1);

      var params = {
        title: formJsonStr,
        userId: 1
      };
      this.$http
        .post("http://db.xxl-wind.com:9091/apiv1/formAdd", params, {
          emulateJSON: true
        })
        .then(function(res) {
          this.$refs["my-modal"].hide();
        });
    },
    toggleModal() {
      // We pass the ID of the button that we want to return focus to
      // when the modal has hidden
      this.$refs["my-modal"].toggle("#toggle-btn");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-title {
  width: 100% !important;
  text-align: center;
}

.title {
  /*background-position:center  center;*/
  background-size: 100% 100%;
}

.part {
  /*background-position:center  center;*/
  background-size: 100% 100%;
}
.main {
  /*background-position:center  center;*/
  background-size: 100% 100%;
}
.card {
  background-color: transparent;
  border: none;
}
.card-box {
  height: 60%;
  background-color: #1e7bcb;
  width: 110%;
  position: relative;
  z-index: 2;
  margin-top: 15%;
  color: #fff;
  text-align: center;
  padding: 20px;
}
.card-box2 {
  margin-left: -10%;
}
.card-box-line {
  height: 10px;
  width: 40%;
  margin-left: 30%;
  border-top: 2px dotted;
}
.card-box-top img {
  height: 60px;
  width: 60px;
  margin-top: -60px;
}
.card-box-title {
  margin-top: -10px;
  font-size: 20px;
}
.card-box-word {
  font-size: 16px;
  cursor: pointer;
}
.title {
  font-size: 20px;
  color: #1f7ccc;
  text-align: center;
  position: relative;
  height: 100px;
  margin-top: 30px;
}
.title img {
  margin-top: 44px;
}
.title-word {
  position: absolute;
  width: 100%;
  top: 25px;
    font-size: 28px;
    font-weight: 700;
}
.title-grey {
  line-height: 50px;
  color: #999999;
  font-size: 14px;
}
.part1box {
  margin-top: 20px;
  width: 100%;
  height: 220px;
  padding: 20px;
}
.part3-blue {
  background-color: #1e7bcb;
  height: 220px;
  width: 100%;
  padding: 20px;
  position: absolute;
  top: 240px;
  transition-property: all;
  transition-duration: 1s;
  color: #fff;
  box-sizing: border-box;
  font-size: 12px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 11;
  -webkit-box-orient: vertical;
}
.change-box2 {
  padding: 0 5px;
  height: 240px;
  overflow: hidden;
  position: relative;
}
.change-box2:hover .part3-blue {
  top: 20px;
}
.part3-totle {
  background-image: url("https://oss-miaojiangmin.oss-cn-hangzhou.aliyuncs.com/zjzc789/WechatIMG426.png");
  padding-bottom: 60px;
  color: #fff;
}
.part1-logo img {
  width: 60px;
  height: 60px;
}
.part1-line {
  height: 2px;
  width: 40%;
  margin-left: 30%;
  margin-bottom: 10px;
  color: #0b69ba;
}
.part2box {
  height: 207.8px;
  width: 240px;
  background-size: 100% 100%;
  padding: 20px;
  text-align: center;
  color: #fff;
}
.part1-word22 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.part1-word2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
}
.six-logo {
  width: 60px;
  height: 50px;
}
.index-part3 {
  width: 100%;
  margin-top: 30px;
}
.index-part4 {
  width: 100%;

  background-image: url(https://oss-miaojiangmin.oss-cn-hangzhou.aliyuncs.com/zjzc789/6_beijing_xiantiao@2x.png);
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center center;
  text-align: center;
}
.part4-logo {
  width: 75px;
  height: 75px;
}
.part5-img {
  padding: 10px;
  display: inline-block;
}
.part5-img img {
  width: 100%;
}
/* 正六边形 */
.sixbox {
  position: relative;
  width: 100px;
  height: 173.2px;
  margin: 0px auto;
  background-color: red;
}
.sixbox:before {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  right: 100px;
  border-width: 86.6px 50px;
  border-style: solid;
  border-color: transparent red transparent transparent;
}
.sixbox:after {
  content: "";
  display: block;
  position: absolute;
  width: 0;
  height: 0;
  left: 100px;
  border-width: 86.6px 50px;
  border-style: solid;
  border-color: transparent transparent transparent red;
  top: 0;
}
.guding {
  position: fixed;
  left: -270px;
  width: 300px;
  top: 35%;
  z-index: 100;
  transition-property: all;
  transition-duration: 1s;
}
.guding img {
  width: 100%;
}
.guding:hover {
  left: -10px;
}
/* 响应式 */
@media screen and (max-width: 1080px) {
  .card-box {
    width: 120%;
    height: 80%;
    margin-top: 7%;
  }
}

@media screen and (max-width: 780px) {
  .card-box {
    width: 100%;
    height: 100%;
    margin-top: 0;
  }
  .card-box-title {
    line-height: 20px;
    font-size: 14px;
  }
  .card-box-top {
    display: none;
  }
  .card-box-top img {
    height: 30px;
    width: 30px;
    margin-top: -10px;
  }
  .card-box2 {
    margin-left: 0;
  }
  .guding {
    display: none;
  }
  .card-box-word {
    overflow: scroll;
    font-size: 12px;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 10;
    -webkit-box-orient: vertical;
  }
}
.beianhao {
  text-align: center;
  height: 40px;
  line-height: 40px;
  background-color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue